import { PRODUCT_TYPES_VALUES } from 'constants/dictionaries';
import { QUERY_PARAMS } from 'constants/queryNames';

import { getProductTypesByQuery } from './getProductTypesByQuery';

export const getProductType = (ctx: App.ReduxAppContext['ctx']) => {
  if (ctx.req.__WL__?.isCreditCardWL) {
    return [PRODUCT_TYPES_VALUES.CREDIT_CARD];
  }

  return getProductTypesByQuery(ctx.query[QUERY_PARAMS.PRODUCT_TYPE]);
};
